import React, { Component } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { connect } from 'react-redux';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
// import { onlyOfficeReadOnly } from './custom_modules/DownloadReport';
import jszip from "jszip";
import $ from "jquery";
import { isMultitenant } from "./custom_functions/Constance";
import { Redirect } from "react-router-dom";
import { LogoutSessionClear } from "./custom_functions/Functions";
import store from "./redux_store/store";
import ErrorBoundary from "./ErrorBoundary.jsx";
import { LinkedInCallback } from "react-linkedin-login-oauth2";

import { v4 as uuidv4 } from "uuid";
import { Client } from '@stomp/stompjs';
import { withTranslation } from "react-multi-lang";
// const Login = lazy(() => import('./custom_modules/Login.jsx'));
// import Socketpg from './custom_modules/socket/Socket.jsx';
import Login from './custom_modules/Login.jsx';
import Register from "./custom_modules/Register.jsx";
import Home from './custom_modules/Home.jsx';
import Notfound from './custom_modules/Notfound.jsx';

import Dashboard from './custom_modules/main_pages/PDashboard.jsx';

import PAuditConfig from './custom_modules/main_pages/audit/PAuditConfig.jsx';
import PAuditTrailHistory from './custom_modules/main_pages/audit/PAuditTrailHistory.jsx';
import PCFRsetting from './custom_modules/main_pages/audit/PCFRsetting.jsx';

import PTestmaster from './custom_modules/main_pages/base_master/PTestmaster.jsx';
import PProjectmaster from './custom_modules/main_pages/base_master/PProjectmaster.jsx';
import PUnLockOrder from './custom_modules/main_pages/base_master/PUnLockOrder.jsx';
import PLogbook from './custom_modules/main_pages/logbook/PLogbook.jsx';
import PBarcodeMaster from './custom_modules/main_pages/base_master/PBarcodeMaster.jsx';
import PSequenceGenerator from './custom_modules/main_pages/base_master/PSequenceGenerator.jsx';

import Report from './custom_modules/main_pages/PReport.jsx';

import Protocols from './custom_modules/main_pages/templates/PProtocols.jsx';
import Sheetcreation from './custom_modules/main_pages/templates/PSheetcreation.jsx';
import SheetMapping from './custom_modules/main_pages/templates/PSheetMapping.jsx';
import Delimiters from './custom_modules/main_pages/methodsetup/PDelimiters.jsx';
import Methoddelimiters from './custom_modules/main_pages/methodsetup/PMethoddelimiters.jsx';
import Methodmaster from './custom_modules/main_pages/methodsetup/PMethodmaster.jsx';
// import InstrumentCategory from './custom_modules/main_pages/methodsetup/PInstrumentCategory.jsx';
import PInstruments from './custom_modules/main_pages/methodsetup/PInstruments.jsx';
import PSdmsMapInstruments from './custom_modules/main_pages/methodsetup/PSdmsMapInstruments.jsx';

import Activeuser from './custom_modules/main_pages/user_management/Pactiveusers.jsx';
import Domain from './custom_modules/main_pages/user_management/Pdomain.jsx';
import Orderworkflow from './custom_modules/main_pages/user_management/Porderworkflow.jsx';
import Passwordpolicy from './custom_modules/main_pages/user_management/Ppasswordpolicy.jsx';
import Projectteam from './custom_modules/main_pages/user_management/Pprojectteam.jsx';
import Protocolworkflow from './custom_modules/main_pages/user_management/Pprotocolworkflow.jsx';
import Sheetworkflow from './custom_modules/main_pages/user_management/Psheetworkflow.jsx';
import Usergroup from './custom_modules/main_pages/user_management/Pusergroup.jsx';
import Usermaster from './custom_modules/main_pages/user_management/Pusermaster.jsx';
import Userrights from './custom_modules/main_pages/user_management/Puserrights.jsx';
import Usersite from './custom_modules/main_pages/user_management/Pusersite.jsx';

import Registertask from './custom_modules/main_pages/orders/PRegistertask.jsx';
import Protocolorder from './custom_modules/main_pages/orders/PProtocolorders.jsx';
import Vieworder from './custom_modules/main_pages/orders/PViewerorder';
import ViewTemplate from './custom_modules/orders/ViewTemplate.tsx';
import PHelp from './custom_modules/main_pages/PHelp.jsx';
import Ptenantlogin from './custom_modules/tenant/Tenantlogin.jsx';
import PMethodsetup from './custom_modules/main_pages/PMethodsetup.jsx';
import PFileViewer from './custom_modules/main_pages/PFileViewer.jsx';

import Ptenantprofile from './custom_modules/tenant/Tenantprofile.jsx';

import Administrator from './custom_modules/administrator/AdministratorLogin.jsx';
import AdministratorHome from './custom_modules/administrator/AdministratorHome.jsx';
import AdministratorUser from './custom_modules/administrator/UserManagement.jsx';
import AdministratorHelpDocument from './custom_modules/administrator/AdministratorHelpDocument.jsx';
import AdministratorHomeDocument from './custom_modules/administrator/AdministratorHomeDocument.jsx';

import PUnitMaster from './custom_modules/main_pages/inventory/PUnitMaster.jsx';
import PSectionMater from './custom_modules/main_pages/inventory/PSectionMaster.jsx';
import Materialcategory from './custom_modules/main_pages/inventory/PMaterialcategory.jsx';
import Materialgrade from './custom_modules/main_pages/inventory/PMaterialGrade.jsx';
import Supplier from './custom_modules/main_pages/inventory/PSupplier.jsx';
import Manufacturer from './custom_modules/main_pages/inventory/PManufacturer.jsx';
import Storagelocation from './custom_modules/main_pages/inventory/PStoragelocation.jsx';
import Material from './custom_modules/main_pages/inventory/PMaterial.jsx';
import Sample from './custom_modules/main_pages/inventory/PSample.jsx';
import Materialinventory from './custom_modules/main_pages/inventory/PMaterialInventory.jsx';
import PInventory from './custom_modules/main_pages/inventory/PInventroy.jsx';
import MaterialType from './custom_modules/main_pages/inventory/PMaterialType.jsx';
import SampleType from './custom_modules/main_pages/inventory/PSampleType.jsx';
import SampleCategory from './custom_modules/main_pages/inventory/PSampleCategory.jsx';
import EquipmentType from './custom_modules/main_pages/inventory/PEquipmentType.jsx';
import Equipment from './custom_modules/main_pages/inventory/PEquipment.jsx';
import EquipmentCat from './custom_modules/main_pages/inventory/PEquipmentCategory.jsx';

import Logbooklist from './custom_modules/logbook/module/Logbooklist.jsx';

import Reportdesigner from './custom_modules/main_pages/reports/PReportdesigner.jsx';
import Reportviewer from './custom_modules/main_pages/reports/PReportviewer.jsx';
import ReportMapping from './custom_modules/main_pages/reports/PReportTemplateMapping.jsx';
import DocumentViewer from './custom_modules/general/DocumentViewer.jsx';
import PFileViewerEdit from './custom_modules/main_pages/PFileViewerEdit.jsx';
import ProtocolFileDownload from "./custom_modules/protocol_orders/ProtocolFileDownload";
import ChatBot from "./custom_modules/chatGPT/ChatBot.jsx";


const options = {
  timeout: 5000,
  position: positions.TOP_RIGHT,
  //offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 999999
  }
};



const mapStateToProps = state => {
  return state;
}

// const stompClient = new Client({
//   brokerURL: window.appUrl.ELNSOCKET + '/protocol-moidification-websocket'
// });

//basename="/ELN"
class App extends Component {

  componentDidMount() {
    window.JSZip = jszip;
    window.jQuery = $;

    if (!sessionStorage.getItem("tabid")) {
      window.tabId = uuidv4();
      sessionStorage.setItem("tabid", window.tabId);
    }
    else {
      window.tabId = sessionStorage.getItem("tabid");

      // stompClient.activate();
      // stompClient.onConnect = (frame) => {
      //   stompClient.publish({
      //     destination: "/eln/removealltabidssocket",
      //     body: JSON.stringify({ tabid: window.tabId })
      //   });

      //   stompClient.subscribe('/notebook/removealltabids', (data) => {
      //     stompClient.deactivate();
      //   });
      // };

    }

    window.addEventListener('unload', this.handleEndConcert, true)
    const redirectUrl = sessionStorage.getItem('redirectUrl');
    if (redirectUrl) {
      sessionStorage.removeItem('redirectUrl');
      window.location.href = redirectUrl;
    }

    if (sessionStorage.getItem('__lock')) {
      console.log("session cleared")
      delete window.tabId;
      delete sessionStorage.tabid;
      LogoutSessionClear();
      console.warn('Found a lock in session storage. The storage was cleared.');
      return (
        <Redirect to="/" />
      );
    }

    sessionStorage.setItem('__lock', '1');

    if (sessionStorage.getItem("__reloadOrder") || sessionStorage.getItem("reloadOrder_Protocol")) {
      let passObjDet1 = { usercode: sessionStorage.getItem("User") };
      const getOrderDetail = sessionStorage.getItem("__reloadOrder");
      const Protocolorder_Ordercode = sessionStorage.getItem("reloadOrder_Protocol");
      if (getOrderDetail !== undefined && getOrderDetail !== null) {
        passObjDet1.Batch = Number(getOrderDetail)
      }
      if (Protocolorder_Ordercode !== undefined && Protocolorder_Ordercode !== null) {
        passObjDet1.protocolordercode = Protocolorder_Ordercode;
      }
      if (Object.keys(passObjDet1).length > 0) {
        const url = window.appUrl.ELN + "/File/unlockorderOnViewClose";
        fetch(url, {
          method: "POST",
          body: JSON.stringify(passObjDet1),
          headers: new Headers({
            Authorization: sessionStorage.getItem("Token"),
            "X-TenantID": sessionStorage.getItem("tenantid"),
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        }).then(response => { }).catch(error => { });
        sessionStorage.removeItem("__reloadOrder");
        sessionStorage.removeItem("reloadOrder_Protocol");
      }

    }

    window.addEventListener('beforeunload', this.handleUnload);
  }

  handleEndConcert = async (e) => {

    const getOrderDetail = store.getState().Sheetview;
    const storedataforprotocolorder = store.getState().OpenprotocolordersDatas;
    const { OrderTestcode } = getOrderDetail || {};
    const { protocolOrder, protocolorderopen } = storedataforprotocolorder || {};
    const lockeduser = protocolOrder?.lockeduser || undefined;
    // if ((getOrderDetail?.OrderTestcode?.batchcode !== undefined && getOrderDetail.OrderTestcode.batchcode !== null) || (storedataforprotocolorder !== undefined && storedataforprotocolorder?.protocolOrder?.protocolordercode && storedataforprotocolorder?.lockeduser !== undefined && storedataforprotocolorder?.lockeduser === Number(sessionStorage.User))) {
    if (OrderTestcode?.batchcode || protocolOrder?.protocolordercode) {
      const orderArray = localStorage.getItem("_viewOrderDetail") !== undefined
        && localStorage.getItem("_viewOrderDetail") !== null && localStorage.getItem("_viewOrderDetail") !== ""
        ? localStorage.getItem("_viewOrderDetail") : [];
      let passObjDet1 = { usercode: sessionStorage.getItem("User") };
      if (getOrderDetail?.OrderTestcode?.batchcode !== undefined && getOrderDetail.OrderTestcode.batchcode !== null) {
        passObjDet1.Batch = getOrderDetail.OrderTestcode.batchcode
        orderArray.push(passObjDet1)
        localStorage.setItem("_viewOrderDetail", JSON.stringify(orderArray));
      }
      if (protocolorderopen && protocolOrder?.protocolordercode && lockeduser === Number(sessionStorage.User)) {
        passObjDet1.protocolordercode = storedataforprotocolorder.protocolOrder?.protocolordercode;
        orderArray.push(passObjDet1)
        localStorage.setItem("_viewOrderDetail", JSON.stringify(orderArray));
      }

      const url = window.appUrl.ELN + "/File/unlockorderOnViewClose";
      if (Object.keys(passObjDet1).length > 0) {
        fetch(url, {
          method: "POST",
          body: JSON.stringify(passObjDet1),
          headers: new Headers({
            Authorization: sessionStorage.getItem("Token"),
            "X-TenantID": sessionStorage.getItem("tenantid"),
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        })
          .then(response => { localStorage.setItem("_viewOrderDetail", ''); })
          .catch(error => { });
      }

      let Celllevel_Auditdatas = store.getState().Celllevel_Auditdatas || [];
      if (Celllevel_Auditdatas.length > 0) {
        fetch(window.appUrl.ELN + "/AuditTrail/silentRecordHandlerForOrder", {
          method: "POST",
          body: JSON.stringify(Celllevel_Auditdatas),
          headers: new Headers({
            Authorization: sessionStorage.getItem("Token"),
            "X-TenantID": sessionStorage.getItem("tenantid"),
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        })
          .then(response => { })
          .catch(error => { });
        // Servicecalls("" + this.ELNurl + "/AuditTrail/silentRecordHandlerForOrder", Celllevel_Auditdatas, (res) => {
        //   console.log("kumu");
        // store.dispatch(Celllevelauditforspreadsheet(
        //   []
        // ));
        // }, (res) => { });
      }
    }
    sessionStorage.removeItem('__lock');
    if (sessionStorage.getItem("_OrderView") !== undefined && sessionStorage.getItem("_OrderView") !== null) {

    } else {
      let passObjDet = { usercode: sessionStorage.getItem("User"), activeusercode: sessionStorage.getItem('activeUserId') };
      fetch("" + window.appUrl.ELN + "/Login/autoLogout", {
        method: "POST",
        body: JSON.stringify(passObjDet),
        headers: new Headers({
          Authorization: sessionStorage.getItem("Token"),
          "X-TenantID": sessionStorage.getItem("tenantid"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      })

    }

    var message = "\o/";

    (e || window.event).returnValue = message; //Gecko + IE
    return message;
  }

  componentWillUnmount() {
    sessionStorage.setItem("__lock", "1");
    window.removeEventListener('beforeunload', this.handleUnload);

    window.addEventListener('unload', this.handleEndConcert, true)
    // this.handleEndConcert()
  }

  handleUnload(e) {

    const getOrderDetail = store.getState().Sheetview;
    const storedataforprotocolorder = store.getState().OpenprotocolordersDatas;
    if (getOrderDetail !== undefined && getOrderDetail !== null && getOrderDetail.OrderTestcode !== undefined && getOrderDetail.OrderTestcode !== null) {
      if (getOrderDetail.OrderTestcode.batchcode !== undefined && getOrderDetail.OrderTestcode.batchcode !== null) {
        sessionStorage.setItem("__reloadOrder", getOrderDetail.OrderTestcode.batchcode);
      }
    }
    if (storedataforprotocolorder?.protocolorderopen && storedataforprotocolorder?.protocolOrder?.protocolordercode !== undefined) {
      sessionStorage.setItem("reloadOrder_Protocol", storedataforprotocolorder.protocolOrder?.protocolordercode);
    }

    const modals = document.querySelectorAll('.modal[style*="display: block"], .react-confirm-alert, .react-confirm-alert-overlay, .modal-backdrop');

    modals?.forEach(modal => {
      const modalTitle = modal.querySelector('.modal-header .modal-title');
      if (modalTitle && modalTitle.textContent.trim() === 'System Timeout') {
        let Orgine;
        if (isMultitenant === 1) {
          Orgine = `${window.origin}${"/#" + sessionStorage.tenantdomain}`;
        } else {
          Orgine = window.origin;
        }
        // window.location.href = Orgine;
        sessionStorage.setItem('redirectUrl', Orgine);
        console.log("This is the System Timeout popup. Redirecting...");
      }
    });


    // eslint-disable-next-line no-useless-escape
    var message = "\o/";
    if (isMultitenant !== 2) {
      (e || window.event).returnValue = message; //Gecko + IE
    }
    return message;
  }

  render() {
    return (<ErrorBoundary>
      <AlertProvider template={AlertTemplate} {...options}>
        {/* <Router basename="/ELN"> */}
        {/* <ChatBot t={this.props.t} /> */}
        <Router >
          <Switch>
            <Route
              exact
              path="/"
              component={Login}
            // onEnter={requireAuth.bind(this, store)}
            />
            <Route path="/linkedin" component={LinkedInCallback} />
            <Route path="/Home" component={Home} />

            <Route path="/dashboard" component={Dashboard} />

            <Route path="/audithistory" component={PAuditTrailHistory} />
            <Route path="/auditconfiguration" component={PAuditConfig} />
            <Route path="/cfrsettings" component={PCFRsetting} />
            {/* <Route path="/instrumentcategory" component={InstrumentCategory} /> */}
            <Route path="/instruments" component={PInstruments} />
            <Route path="/sdmsmappedinstruments" component={PSdmsMapInstruments} />
            <Route path="/delimiters" component={Delimiters} />
            <Route path="/methoddelimiters" component={Methoddelimiters} />
            <Route path="/methodmaster" component={Methodmaster} />

            <Route path="/audithistory" component={PAuditTrailHistory} />
            <Route path="/auditconfiguration" component={PAuditConfig} />
            <Route path="/cfrsettings" component={PCFRsetting} />

            <Route path="/testmaster" component={PTestmaster} />
            <Route path="/projectmaster" component={PProjectmaster} />
            <Route path="/unlockorder" component={PUnLockOrder} />
            <Route path="/logbook" component={PLogbook} />

            <Route path="/registertask" component={Registertask} />
            <Route path="/Protocolorder" component={Protocolorder} />
            <Route path="/vieworder" component={Vieworder} />
            <Route path="/Viewtemplate" component={ViewTemplate} />

            <Route path="/report" component={Report} />

            <Route path="/sheetcreation" component={Sheetcreation} />
            <Route path="/protocols" component={Protocols} />
            <Route path="/sheetmapping" component={SheetMapping} />

            <Route path="/activeuser" component={Activeuser} />
            <Route path="/domain" component={Domain} />
            <Route path="/Orderworkflow" component={Orderworkflow} />
            <Route path="/Passwordpolicy" component={Passwordpolicy} />
            <Route path="/Projectteam" component={Projectteam} />
            <Route path="/Protocolworkflow" component={Protocolworkflow} />

            <Route path="/Sheetworkflow" component={Sheetworkflow} />
            <Route path="/Usergroup" component={isMultitenant === 2 ? Notfound : Usergroup} />
            <Route path="/Usermaster" component={Usermaster} />
            <Route path="/Userrights" component={isMultitenant === 2 ? Notfound : Userrights} />
            <Route path="/Usersite" component={isMultitenant === 2 ? Notfound : Usersite} />


            <Route path="/tenantlogin" component={Ptenantlogin} />
            <Route path="/tenantprofile" component={Ptenantprofile} />
            <Route path="/administrator" component={Administrator} />
            <Route path="/ad_organisation" component={AdministratorHome} />
            <Route path="/ad_usermanagement" component={AdministratorUser} />
            <Route path="/ad_adhelpdocument" component={AdministratorHelpDocument} />
            <Route path="/ad_adhomedocument" component={AdministratorHomeDocument} />
            <Route path="/help" component={PHelp} />
            <Route path="/fileviewer" component={PFileViewer} />
            <Route path="/Fileedit" component={PFileViewerEdit} />

            <Route path="/methodsetup" component={PMethodsetup} />

            <Route path="/instrumentstype" component={EquipmentType} />
            <Route path="/instrumentsmaster" component={Equipment} />
            <Route path="/instrumentscategory" component={EquipmentCat} />

            <Route path="/sectionmaster" component={PSectionMater} />
            <Route path="/materialtype" component={MaterialType} />
            <Route path="/sampletype" component={SampleType} />
            <Route path="/samplecategory" component={SampleCategory} />
            <Route path="/unitmaster" component={PUnitMaster} />
            <Route path="/materialcategory" component={Materialcategory} />
            <Route path="/materialgrade" component={Materialgrade} />
            <Route path="/supplier" component={Supplier} />
            <Route path="/manufacturer" component={Manufacturer} />
            <Route path="/storagelocation" component={Storagelocation} />
            <Route path="/material" component={Material} />
            <Route path="/sample" component={Sample} />
            <Route path="/materialinventory" component={Materialinventory} />
            <Route path="/logbook" component={Logbooklist} />
            <Route path="/inventory" component={PInventory} />
            <Route path="/reportdesigner" component={Reportdesigner} />
            <Route path="/reportviewer" component={Reportviewer} />
            <Route path="/reportMapping" component={ReportMapping} />
            <Route path="/register" component={isMultitenant === 2 ? Register : Notfound} />
            <Route path="/documentviewer" component={DocumentViewer} />
            <Route path="/protocolfiledownload" component={ProtocolFileDownload} />

            <Route path="/labelmaster" component={PBarcodeMaster} />

            <Route path="/sequencegenerator" component={PSequenceGenerator} />

            <Route component={Notfound} />
          </Switch>
        </Router>
      </AlertProvider >
    </ErrorBoundary>
    );
  }
}
export default connect(mapStateToProps)(withTranslation(App), { forwardRef: true });
// const AppWithAlert = withAlert()(App);
// export default connect(mapStateToProps)(AppWithAlert, { forwardRef: true });
